<template>

    <svg
        xmlns="http://www.w3.org/2000/svg"
        :width="size || width"
        :height="size || height"
        :viewBox="`0 0 ${vbWidth} ${vbHeight}`"
        :aria-labelledby="icon">

        <g :fill="resolvedColor">
            <slot>
                <component :is="`icon-${icon}`"></component>
            </slot>
        </g>

    </svg>

</template>

<script lang="ts">

import { Component, Prop, Vue } from 'vue-facing-decorator';

import type { ComponentProps } from '@wittignl/js-core';
import { createComponentMixin } from '@wittignl/js-core';

@Component({
    name: 'ui-icon'
})
export default class Icon extends Vue {

    @Prop({ type: String })
    icon: string;

    @Prop({ type: [Number, String], default: 24 })
    width: number | string;

    @Prop({ type: [Number, String], default: 24 })
    height: number | string;

    @Prop({ type: [Number, String] })
    size: number | string;

    @Prop({ type: [Number, String], default: 24 })
    vbWidth: number | string;

    @Prop({ type: [Number, String], default: 24 })
    vbHeight: number | string;

    @Prop({ type: String, default: '#000000' })
    color: string;

    get resolvedColor() {

        if(!this.color){
            return null;
        }

        if(this.$style && this.color.charAt(0) === '$'){
            return this.$style.getColor(this.color.substring(1));
        }

        return this.color;
    }
}

export type IconComp = InstanceType<typeof Icon>
export type IconProps = ComponentProps<IconComp>
export const iconCompMixin = createComponentMixin(Icon)

</script>